import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { MatCheckbox } from '@angular/material/checkbox'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'

export type ToggleMenuOptions = {
  [id: string]: boolean
}

export function getActiveToggleMenuOptionIds(toggleMenuOptions: ToggleMenuOptions) {
  return Object.entries(toggleMenuOptions)
    .filter(([key, value]) => value)
    .map(([key]) => key)
}

@Component({
  selector: 'app-toggle-menu',
  imports: [TranslatePipe, MatMenuTrigger, MatIcon, MatMenu, MatCheckbox, FormsModule, MatMenuItem, MatButton],
  templateUrl: './toggle-menu.component.html',
  styleUrl: './toggle-menu.component.scss',
})
export class ToggleMenuComponent {
  @Input({ required: true })
  labelTranslationKey!: string

  @Input({ required: true })
  options!: ToggleMenuOptions

  @Output()
  update = new EventEmitter<ToggleMenuOptions>()

  get optionsArray(): { id: string; value: boolean }[] {
    return Object.entries(this.options).map(([id, value]) => ({ id, value }))
  }

  toggleOption(id: string) {
    this.update.emit({ ...this.options, [id]: !this.options[id] })
  }
}
